import { render } from "./LetterHex.vue?vue&type=template&id=50d2573a&scoped=true"
import script from "./LetterHex.vue?vue&type=script&lang=js"
export * from "./LetterHex.vue?vue&type=script&lang=js"

import "./LetterHex.vue?vue&type=style&index=0&id=50d2573a&scoped=true&lang=css"

import exportComponent from "/home/rich/web/spelling-bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d2573a"]])

export default __exports__